import { Routes } from '@angular/router';

export const MOBILE_FEEDBACK_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/feedback-list/feedback-list.component').then(c => c.FeedbackListComponent),
  },
  {
    path: 'new',
    loadComponent: () => import('./feedback.component').then(c => c.FeedbackComponent),
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./pages/feedback-details/feedback-details.component').then(
        c => c.FeedbackDetailsComponent,
      ),
  },
  {
    path: ':id/add',
    loadComponent: () =>
      import('./pages/feedback-add-message/feedback-add-message.component').then(
        c => c.FeedbackAddMessageComponent,
      ),
  },
];
